module.exports = __webpack_public_path__ + "img/avatar_li_fh.0a08baaa.png";